import { useState } from 'react'
import { Trash2 } from 'lucide-react'
import { Button } from '@teach/ui'
import { DeleteConfirmDialog } from './DeleteConfirmDialog'
import { lockHint } from './lockHint'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  lessonNumber: number
  isCourseAuthor: boolean
  /** Курс на проверке: состав курса в заявке, удалять урок нельзя. */
  isFrozen: boolean
  onConfirm: () => void
}

/**
 * «Удалить урок» — внизу вкладки «Инфо» панели урока. Раньше корзинка висела
 * на плашке урока в ленте и появлялась от любого наведения: удаление целого
 * урока в одно движение мыши мимо. Здесь оно стоит отдельно, после всех полей.
 */
export const LessonDeleteButton = ({
  lessonNumber,
  isCourseAuthor,
  isFrozen,
  onConfirm,
}: Props) => {
  const m = useMessages(messages)
  const [open, setOpen] = useState(false)
  return (
    <>
      <Button
        variant="outline"
        onClick={() => setOpen(true)}
        disabled={!isCourseAuthor || isFrozen}
        title={lockHint(isCourseAuthor, isFrozen)}
        className="w-full border-destructive/40 text-destructive hover:border-destructive hover:bg-destructive/10"
      >
        <Trash2 />
        {m.deleteLessonButton}
      </Button>
      <DeleteConfirmDialog
        open={open}
        title={m.deleteLesson(lessonNumber)}
        description={m.deleteLessonDescription}
        onOpenChange={setOpen}
        onConfirm={onConfirm}
      />
    </>
  )
}
